export const NAME = 'eshopHeader';
export const DEFAULT_STATE = {};
